<div class="sbuttons">

  
 <!--
  <a href="#" target="_blank" class="sbutton twitt" tooltip="טוויטר" (click)="shareTweetUrl()" >
    <i class="fab fa-twitter"></i>
  </a>
 -->

 <!--
 <a href="#" target="_blank" class="sbutton instagram" tooltip="אינסטגרם" (click)="shareInstaUrl()">
    <i class="fab fa-instagram"></i>
  </a>
 -->
 
  <!--
  <a href="#" target="_blank" class="sbutton fb" tooltip="פיסבוק" (click)="shareFacebookUrl()">
    <i class="fab fa-facebook-f" ></i>
  </a>
  -->

  <a href="#" target="_blank" class="sbutton envelope" [attr.tooltip]="'RESTORE.EMAIL' | translate" (click)="shareMailUrl()" >
    <i class="fas fa-envelope" style="font-size: 16px;"></i>
  </a>
  <a href="#" target="_blank" class="sbutton whatsapp" [attr.tooltip]="'SOCIAL.WHATSAPP' | translate" (click)="shareWhatsapp()">
    <i class="fab fa-whatsapp"></i>
  </a>
  <a target="_blank" class="sbutton mainsbutton" tooltip="Share"><i class="fas fa-share-alt"></i></a>
</div>
